import React, { Component } from 'react'

import Create from '../../crud/create'
import menuItems from './menuItems'

import loadDiscounts from './loadDiscounts'
import fields from './fields'

class CreateOrderDiscount extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = { discounts: [] }
  }

  componentDidMount () {
    loadDiscounts(this.props.params.orderId)
      .then(discounts => {
        if (discounts) this.setState({ discounts })
      })
  }

  render () {
    const { orderId } = this.props.params
    const { discounts } = this.state

    return (
      <Create
// @ts-ignore
        title='Create Order Discount'
        fields={fields(discounts)}
        apiPath='admin/order_discounts/multiply'
        successRedirectPath={`/ecommerce/orders/${orderId}/discounts`}
        buildMenuItems={menuItems}
        resource={{
          order_id: orderId,
          multiplier: 1
        }}
      />
    )
  }
}

export default CreateOrderDiscount
